import { IImage } from '@/components/admin/Images/interfaces';
import IImageModel from '@/components/interfaces/ImageModel';

export interface ImageModel {
  id: string | number;
}

export interface Image {
  id: number;
  credits: string | null;
  descriptionConfidence: number | null;
  descriptionEn: string | null;
  descriptionEs: string | null;
  imageUrl: string;
  imageEsUrl: string;
  fileName: string;
  fileNameEs: string | null;
  fileSize: string | null;
  numberOfUses: number | null;
  resolution: string | null;
  thumbnail: string;
  titleEn: string | null;
  titleEs: string | null;
  hasText: boolean;
  englishImageOnly: boolean;
  __typename: 'Image';
}

export const ROW_HEADERS = [
  'imageData',
  'useAsPrimary',
  'fileName',
  'numberOfUses',
  'size',
  'dimensions',
  'credits',
  'license',
  'englishImageOnly',
  'altText',
] as const;

export type RowHeader = typeof ROW_HEADERS[number];

export interface TableRowData {
  id: string;
  header: RowHeader;
  uploadedImage: string;
  duplicateImages: (string | null)[];
}

export type MergeImagesResponse = {
  image: IImage;
  updated_image_models: IImageModel[]
};

